'use strict';

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */

var lang = require('zero-lang');
var c3mroMerge = require('./c3mro');

module.exports = function () /*name, superClasses, protoObj*/{
    var uberClass = undefined;
    var tempConstructor = undefined;
    var lin = '_linearization';
    var args = lang.toArray(arguments);
    var name = lang.isString(args[0]) ? args.shift() : '';
    var superClasses = args.length > 1 ? args.shift() : [];
    var protoObj = args[0] ? args.shift() : {};
    var bases = [];
    var hasCtor = false;
    var Tmp = function Tmp() {};
    var ctor = function ctor() {};

    superClasses = lang.isArray(superClasses) ? superClasses : [superClasses];
    lang.each(superClasses, function (clazz) {
        clazz[lin] = clazz[lin] || [clazz];
        bases.push(clazz[lin]);
    });

    if (bases.length) {
        bases.push(superClasses);
        bases = c3mroMerge.apply(null, bases);
    }

    tempConstructor = protoObj.constructor;
    if (tempConstructor !== Object.prototype.constructor) {
        hasCtor = true;
        ctor = tempConstructor;
    }

    ctor[lin] = [ctor].concat(bases);
    ctor.parents = lang.toArray(bases);

    protoObj.constructor = ctor;
    while (uberClass = bases.shift()) {
        protoObj = lang.extend({}, uberClass.prototype, protoObj);
        Tmp.prototype = protoObj;
        if (!hasCtor) {
            protoObj.constructor = ctor;
        }
        protoObj = new Tmp();
    }

    ctor.className = name;
    ctor.prototype = protoObj;
    ctor.prototype.constructor = ctor;

    return ctor;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-net/~/zero-async/~/zero-oop/declare.js
 ** module id = 9
 ** module chunks = 0 1
 **/